// extracted by mini-css-extract-plugin
export default {"descriptionCell":"QuarryTableView_descriptionCell__Rl+4L","copyIcon":"QuarryTableView_copyIcon__8MMQd","PopoverContent":"QuarryTableView_PopoverContent__r5R9U"};